exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-modal-generar-recepcion .red--text {\n  color: red !important;\n  border-color: red !important;\n}\n.add-modal-generar-recepcion div.red--text .v-input__control,\n.add-modal-generar-recepcion div.red--text .v-input__slot:hover:before,\n.add-modal-generar-recepcion div.red--text input {\n  color: red !important;\n  border-color: red !important;\n}\n", ""]);

// exports
